/**
 * Работа с настройками поиска (скрытые языки и словари)
 * # ⛓️ CURSOR_ANCHOR:search:history-settings
 */

// Получение скрытых языков из cookies
function getHiddenLangs() {
  if (window.SEARCH_UTILS && window.SEARCH_UTILS.getCookie) {
    var key = typeof SETTINGS_LANGS_KEY !== 'undefined' ? SETTINGS_LANGS_KEY : window.SETTINGS_LANGS_KEY;
    var value = window.SEARCH_UTILS.getCookie(key);
    return value ? value.split(',') : [];
  }
  return [];
}

// Получение скрытых словарей из cookies
function getHiddenDicts() {
  if (window.SEARCH_UTILS && window.SEARCH_UTILS.getCookie) {
    var key = typeof SETTINGS_DICTS_KEY !== 'undefined' ? SETTINGS_DICTS_KEY : window.SETTINGS_DICTS_KEY;
    var value = window.SEARCH_UTILS.getCookie(key);
    if (!value) return [];
    
    // Фильтруем только новые значения с префиксом lang:
    // Это очищает куки от старого "мусора", который мог блокировать словари некорректно
    var items = value.split(',');
    var filtered = items.filter(function(item) {
      return item.indexOf(':') !== -1;
    });
    
    // Если были старые значения, перезаписываем куку чистым списком
    if (filtered.length !== items.length) {
      saveHiddenDicts(filtered);
    }
    
    return filtered;
  }
  return [];
}

// Account-sync hook shared by the settings writers below.
function _notifySettingsMutated() {
  document.dispatchEvent(new CustomEvent('slovary-state-mutated', { detail: { kind: 'settings' } }));
}

// Сохранение скрытых языков в cookies
function saveHiddenLangs(langs) {
  if (window.SEARCH_UTILS && window.SEARCH_UTILS.setCookie) {
    var key = typeof SETTINGS_LANGS_KEY !== 'undefined' ? SETTINGS_LANGS_KEY : window.SETTINGS_LANGS_KEY;
    window.SEARCH_UTILS.setCookie(key, langs.join(','), 365);
    _notifySettingsMutated();
  }
}

// Сохранение скрытых словарей в cookies
function saveHiddenDicts(dicts) {
  if (window.SEARCH_UTILS && window.SEARCH_UTILS.setCookie) {
    var key = typeof SETTINGS_DICTS_KEY !== 'undefined' ? SETTINGS_DICTS_KEY : window.SETTINGS_DICTS_KEY;
    window.SEARCH_UTILS.setCookie(key, dicts.join(','), 365);
    _notifySettingsMutated();
  }
}

// Получение настройки клика для поиска
function getClickSearchSetting() {
  if (window.SEARCH_UTILS && window.SEARCH_UTILS.getCookie) {
    var key = typeof SETTINGS_CLICK_SEARCH_KEY !== 'undefined' ? SETTINGS_CLICK_SEARCH_KEY : window.SETTINGS_CLICK_SEARCH_KEY;
    var value = window.SEARCH_UTILS.getCookie(key);
    return value === 'true'; // По умолчанию false (выключено)
  }
  return false;
}

// Сохранение настройки клика для поиска
function saveClickSearchSetting(enabled) {
  if (window.SEARCH_UTILS && window.SEARCH_UTILS.setCookie) {
    var key = typeof SETTINGS_CLICK_SEARCH_KEY !== 'undefined' ? SETTINGS_CLICK_SEARCH_KEY : window.SETTINGS_CLICK_SEARCH_KEY;
    window.SEARCH_UTILS.setCookie(key, enabled ? 'true' : 'false', 365);
    _notifySettingsMutated();
  }
}

// Применение настроек языков (скрытие вкладок)
function applyLanguageSettings() {
  var hiddenLangs = getHiddenLangs();
  var langLinks = document.querySelectorAll('#langs a:not(.langs-book-icon)');
  var hasHidden = false;
  
  langLinks.forEach(function(link) {
    var href = link.getAttribute('href');
    if (href) {
      var langCode = href.replace(/\//g, '');
      if (hiddenLangs.includes(langCode)) {
        link.style.display = 'none';
        hasHidden = true;
      } else {
        link.style.display = '';
      }
    }
  });

  // Управление кнопкой "+" (добавить язык)
  var langsContainer = document.getElementById('langs');
  if (langsContainer) {
    var addBtn = langsContainer.querySelector('.add-lang-btn');
    if (hasHidden) {
      if (!addBtn) {
        addBtn = document.createElement('button');
        addBtn.type = 'button';
        addBtn.className = 'add-lang-btn';
        addBtn.textContent = '+';
        addBtn.onclick = function() {
          if (typeof window.openSearchSettingsModal === 'function') {
            window.openSearchSettingsModal();
          }
        };
        langsContainer.prepend(addBtn);
      }
    } else if (addBtn) {
      addBtn.parentNode.removeChild(addBtn);
    }
  }
  
  // Обновляем состояние глобального флага
  window.SETTINGS_CLICK_SEARCH = getClickSearchSetting();
}

// Переключение видимости списка словарей в настройках
function toggleDictsList(langCode) {
  var section = document.querySelector('.language-group[data-lang-group="' + langCode + '"]');
  if (section) {
    section.classList.toggle('expanded');
  }
}

// Функция для показа тултипа с полным описанием словаря
function openDictDescTooltip(event, description) {
  event.stopPropagation();
  event.preventDefault();
  
  // Если тултип уже открыт на этом элементе, закрываем его
  var existing = document.querySelector('.dict-desc-tooltip');
  if (existing) {
    var wasSame = existing.getAttribute('data-target') === event.currentTarget.innerHTML;
    existing.parentNode.removeChild(existing);
    if (wasSame) return;
  }
  
  var tooltip = document.createElement('div');
  tooltip.className = 'dict-desc-tooltip';
  
  // Берем только чистый текст без тегов
  var tempDiv = document.createElement('div');
  tempDiv.innerHTML = description.replace(/<b-r><\/?b-r>/g, ' ');
  var cleanText = tempDiv.textContent || tempDiv.innerText || "";
  tooltip.textContent = cleanText;
  
  tooltip.setAttribute('data-target', event.currentTarget.innerHTML);
  
  // Устанавливаем очень высокий z-index, чтобы быть выше всех модалок
  tooltip.style.zIndex = '999999';
  
  document.body.appendChild(tooltip);
  
  var rect = event.currentTarget.getBoundingClientRect();
  var tooltipRect = tooltip.getBoundingClientRect();
  
  var top = rect.top + window.scrollY - tooltipRect.height - 10;
  var left = rect.left + window.scrollX - (tooltipRect.width / 2) + (rect.width / 2);
  
  // Проверка границ экрана
  if (left < 10) left = 10;
  if (left + tooltipRect.width > window.innerWidth - 10) left = window.innerWidth - tooltipRect.width - 10;
  if (top < 10) top = rect.bottom + window.scrollY + 10;
  
  tooltip.style.top = top + 'px';
  tooltip.style.left = left + 'px';
  
  // Закрытие при клике вне тултипа
  setTimeout(function() {
    var closeHandler = function(e) {
      if (!tooltip.contains(e.target)) {
        if (tooltip.parentNode) tooltip.parentNode.removeChild(tooltip);
        document.removeEventListener('click', closeHandler);
      }
    };
    document.addEventListener('click', closeHandler);
  }, 10);
}

// Инициализация вкладок и чекбоксов в модалке
function initModalTabs() {
  var tabs = document.querySelectorAll('.search-modal-tab');
  var contents = document.querySelectorAll('.search-modal-tab-content');
  
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var targetTab = this.getAttribute('data-tab');
      
      // Переключаем активный таб
      tabs.forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
      
      // Переключаем контент
      contents.forEach(function(c) {
        c.classList.remove('active');
        if (c.id === 'tab-' + targetTab) {
          c.classList.add('active');
        }
      });

      // Если переключились на настройки, пересчитываем indeterminate состояние
      if (targetTab === 'settings') {
        var hiddenLangs = getHiddenLangs();
        langCheckboxes.forEach(function(cb) {
          var lang = cb.getAttribute('data-lang');
          updateLangIndeterminateState(lang);
        });
        
        // Обновляем состояние чекбокса клика и активные подписи
        var clickSearchCb = document.getElementById('settings-click-search');
        if (clickSearchCb) {
          var isEnabled = getClickSearchSetting();
          clickSearchCb.checked = isEnabled;
          window.SETTINGS_CLICK_SEARCH = isEnabled;
          updateClickModeLabels(isEnabled);
        }
      }
    });
  });

  // Инициализация чекбокса клика для поиска
  var clickSearchCb = document.getElementById('settings-click-search');
  if (clickSearchCb) {
    // Устанавливаем начальное состояние из кук при загрузке
    var initialEnabled = getClickSearchSetting();
    clickSearchCb.checked = initialEnabled;
    window.SETTINGS_CLICK_SEARCH = initialEnabled;
    updateClickModeLabels(initialEnabled);

    clickSearchCb.addEventListener('change', function() {
      var isEnabled = this.checked;
      saveClickSearchSetting(isEnabled);
      updateClickModeLabels(isEnabled);
      // Обновляем глобальный флаг мгновенно
      window.SETTINGS_CLICK_SEARCH = isEnabled;
    });

    // Подписи по сторонам toggle кликабельны: «Два клика» → off, «Один клик» → on.
    var optTwo = document.getElementById('click-mode-two');
    var optOne = document.getElementById('click-mode-one');
    function setClickMode(enabled) {
      if (clickSearchCb.checked === enabled) return;
      clickSearchCb.checked = enabled;
      clickSearchCb.dispatchEvent(new Event('change'));
    }
    if (optTwo) optTwo.addEventListener('click', function() { setClickMode(false); });
    if (optOne) optOne.addEventListener('click', function() { setClickMode(true); });
  }

  // Подсветка активной стороны переключателя «Два клика | Один клик».
  function updateClickModeLabels(isEnabled) {
    var optTwo = document.getElementById('click-mode-two');
    var optOne = document.getElementById('click-mode-one');
    if (optTwo) optTwo.classList.toggle('active', !isEnabled);
    if (optOne) optOne.classList.toggle('active', isEnabled);
  }
  
  // Инициализация чекбоксов языков и словарей
  var hiddenLangs = getHiddenLangs();
  var hiddenDicts = getHiddenDicts();
  
  var langCheckboxes = document.querySelectorAll('.lang-setting-checkbox');
  var dictCheckboxes = document.querySelectorAll('.dict-setting-checkbox');
  var groupCheckboxes = document.querySelectorAll('.group-setting-checkbox');

  // Функция для обновления состояния словарей на основе языка
  function updateDictsStateByLang(lang, isEnabled) {
    var currentHidden = getHiddenDicts();
    dictCheckboxes.forEach(function(dcb) {
      if (dcb.getAttribute('data-lang') === lang) {
        dcb.checked = isEnabled;
        var dictCode = dcb.getAttribute('data-dict');
        var dictKey = lang + ':' + dictCode;
        if (isEnabled) {
          currentHidden = currentHidden.filter(function(d) { return d !== dictKey; });
        } else {
          if (!currentHidden.includes(dictKey)) {
            currentHidden.push(dictKey);
          }
        }
      }
    });
    
    // Обновляем состояние групповых чекбоксов
    groupCheckboxes.forEach(function(gcb) {
      if (gcb.getAttribute('data-lang') === lang) {
        gcb.checked = isEnabled;
        gcb.indeterminate = false;
      }
    });

    saveHiddenDicts(currentHidden);
    updateLangIndeterminateState(lang);
    updateLangDashboard();
  }

  // Функция для обновления состояния словарей на основе группы
  function updateDictsStateByGroup(lang, groupType, isEnabled) {
    var currentHidden = getHiddenDicts();
    dictCheckboxes.forEach(function(dcb) {
      if (dcb.getAttribute('data-lang') === lang && dcb.getAttribute('data-group') === groupType) {
        dcb.checked = isEnabled;
        var dictCode = dcb.getAttribute('data-dict');
        var dictKey = lang + ':' + dictCode;
        if (isEnabled) {
          currentHidden = currentHidden.filter(function(d) { return d !== dictKey; });
        } else {
          if (!currentHidden.includes(dictKey)) {
            currentHidden.push(dictKey);
          }
        }
      }
    });
    saveHiddenDicts(currentHidden);
    updateLangIndeterminateState(lang);
    updateLangDashboard();
  }

  // Функция для обновления состояния "неполного выделения" (indeterminate) для чекбокса группы
  function updateGroupIndeterminateState(lang, groupType) {
    var groupCb = document.querySelector('.group-setting-checkbox[data-lang="' + lang + '"][data-group="' + groupType + '"]');
    if (!groupCb) return;

    var dicts = Array.from(document.querySelectorAll('.dict-setting-checkbox[data-lang="' + lang + '"][data-group="' + groupType + '"]'));
    if (dicts.length === 0) return;

    var checkedCount = 0;
    dicts.forEach(function(d) {
      if (d.checked) checkedCount++;
    });

    if (checkedCount === 0) {
      groupCb.checked = false;
      groupCb.indeterminate = false;
    } else if (checkedCount === dicts.length) {
      groupCb.checked = true;
      groupCb.indeterminate = false;
    } else {
      groupCb.checked = true;
      groupCb.indeterminate = true;
    }
  }

  // Функция для обновления состояния "неполного выделения" (indeterminate) для чекбокса языка
  // Использует CSS класс .is-partial вместо :indeterminate, т.к. accent-color ломает отрисовку
  function updateLangIndeterminateState(lang) {
    var langCb = document.getElementById('lang-cb-' + lang);
    var dictsContainer = document.getElementById('dicts-list-' + lang);
    
    if (!langCb || !dictsContainer) return;

    var dicts = Array.from(dictsContainer.querySelectorAll('.dict-setting-checkbox'));
    if (dicts.length === 0) return;

    var checkedCount = 0;
    dicts.forEach(function(d) {
      if (d.checked) checkedCount++;
    });
    
    // Очистка inline стилей и класса (сброс к дефолту)
    function clearPartialState() {
      langCb.classList.remove('is-partial');
      langCb.indeterminate = false;
      langCb.style.removeProperty('appearance');
      langCb.style.removeProperty('-webkit-appearance');
      langCb.style.removeProperty('background-color');
      langCb.style.removeProperty('border-radius');
      langCb.style.removeProperty('background-image');
      langCb.style.removeProperty('background-repeat');
      langCb.style.removeProperty('background-position');
      langCb.style.removeProperty('background-size');
      langCb.style.removeProperty('border');
    }
    
    if (checkedCount === 0) {
      // Ничего не выбрано
      clearPartialState();
      langCb.checked = false;
    } else if (checkedCount === dicts.length) {
      // Все выбрано
      clearPartialState();
      langCb.checked = true;
    } else {
      // Частичное выделение - используем CSS класс + inline стили как fallback
      langCb.indeterminate = true;
      langCb.checked = true; // Для правильного поведения при клике
      langCb.classList.add('is-partial');
      
      // Inline стили как fallback для случаев, когда CSS класс не применяется
      langCb.style.setProperty('appearance', 'none', 'important');
      langCb.style.setProperty('-webkit-appearance', 'none', 'important');
      langCb.style.setProperty('background-color', 'var(--color-brand-accent)', 'important');
      langCb.style.setProperty('border-radius', '3px', 'important');
      langCb.style.setProperty('border', 'none', 'important');
      langCb.style.setProperty('background-image', 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'white\' stroke-width=\'4\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3E%3Cline x1=\'5\' y1=\'12\' x2=\'19\' y2=\'12\'%3E%3C/line%3E%3C/svg%3E")', 'important');
      langCb.style.setProperty('background-repeat', 'no-repeat', 'important');
      langCb.style.setProperty('background-position', 'center', 'important');
      langCb.style.setProperty('background-size', '12px', 'important');
    }
  }
  
  // 1. Сначала инициализируем состояние всех словарей
  dictCheckboxes.forEach(function(cb) {
    var dict = cb.getAttribute('data-dict');
    var lang = cb.getAttribute('data-lang');
    var group = cb.getAttribute('data-group');
    var dictKey = lang + ':' + dict;
    cb.checked = !hiddenDicts.includes(dictKey);
    
    cb.addEventListener('change', function() {
      // Не даем снять последнюю галку со словаря
      if (!this.checked) {
        var anyOtherEnabled = Array.from(dictCheckboxes).some(function(dcb) {
          return dcb.checked && dcb !== cb;
        });
        if (!anyOtherEnabled) {
          this.checked = true;
          return;
        }
      }
      
      var currentHidden = getHiddenDicts();
      if (this.checked) {
        currentHidden = currentHidden.filter(function(d) { return d !== dictKey; });
        
        // Если включили словарь, проверяем не нужно ли включить язык
        var langCb = document.querySelector('.lang-setting-checkbox[data-lang="' + lang + '"]');
        if (langCb && !langCb.checked) {
          langCb.checked = true;
          var hLangs = getHiddenLangs().filter(function(l) { return l !== lang; });
          saveHiddenLangs(hLangs);
          applyLanguageSettings();
        }
      } else {
        if (!currentHidden.includes(dictKey)) {
          currentHidden.push(dictKey);
        }
        
        // Если выключили все словари языка, выключаем и сам язык
        var allLangDicts = Array.from(document.querySelectorAll('.dict-setting-checkbox[data-lang="' + lang + '"]'));
        var anyEnabled = allLangDicts.some(function(d) { return d.checked; });
        if (!anyEnabled) {
          var langCb = document.querySelector('.lang-setting-checkbox[data-lang="' + lang + '"]');
          if (langCb && langCb.checked) {
            langCb.checked = false;
            var hLangs = getHiddenLangs();
            if (!hLangs.includes(lang)) hLangs.push(lang);
            saveHiddenLangs(hLangs);
            applyLanguageSettings();
          }
        }
      }
      saveHiddenDicts(currentHidden);
      if (group) {
        updateGroupIndeterminateState(lang, group);
      }
      updateLangIndeterminateState(lang);
      updateLangDashboard();
    });
  });

  // 2. Инициализируем групповые чекбоксы
  groupCheckboxes.forEach(function(cb) {
    var lang = cb.getAttribute('data-lang');
    var group = cb.getAttribute('data-group');
    updateGroupIndeterminateState(lang, group);

    cb.addEventListener('change', function() {
      var isEnabled = this.checked;
      
      // Не даем снять последнюю галку, если это приведет к полному отключению всех словарей
      if (!isEnabled) {
        var anyRemainingEnabled = Array.from(dictCheckboxes).some(function(dcb) {
          // Проверяем, останется ли хоть один включенный словарь НЕ из этой группы
          var isInThisGroup = dcb.getAttribute('data-lang') === lang && dcb.getAttribute('data-group') === group;
          return dcb.checked && !isInThisGroup;
        });
        if (!anyRemainingEnabled) {
          this.checked = true;
          return;
        }
      }

      updateDictsStateByGroup(lang, group, isEnabled);
      
      // Если включили группу, проверяем не нужно ли включить язык
      if (isEnabled) {
        var langCb = document.querySelector('.lang-setting-checkbox[data-lang="' + lang + '"]');
        if (langCb && !langCb.checked) {
          langCb.checked = true;
          var hLangs = getHiddenLangs().filter(function(l) { return l !== lang; });
          saveHiddenLangs(hLangs);
          applyLanguageSettings();
        }
      } else {
        // Если выключили группу и это была последняя включенная группа языка, выключаем язык
        var otherGroups = Array.from(groupCheckboxes).filter(function(gcb) {
          return gcb.getAttribute('data-lang') === lang && gcb !== cb;
        });
        var anyGroupEnabled = otherGroups.some(function(gcb) { return gcb.checked; });
        if (!anyGroupEnabled) {
          var langCb = document.querySelector('.lang-setting-checkbox[data-lang="' + lang + '"]');
          if (langCb && langCb.checked) {
            langCb.checked = false;
            var hLangs = getHiddenLangs();
            if (!hLangs.includes(lang)) hLangs.push(lang);
            saveHiddenLangs(hLangs);
            applyLanguageSettings();
          }
        }
      }
    });
  });

  // 3. Затем инициализируем языки и их indeterminate состояние
  langCheckboxes.forEach(function(cb) {
    var lang = cb.getAttribute('data-lang');
    cb.checked = !hiddenLangs.includes(lang);
    
    // Теперь, когда словари уже имеют верный .checked, это сработает правильно
    updateLangIndeterminateState(lang);
    
    cb.addEventListener('change', function() {
      var isEnabled = this.checked;
      
      // Не даем снять последнюю галку с языка
      if (!isEnabled) {
        var anyOtherEnabled = Array.from(langCheckboxes).some(function(lcb) {
          return lcb.checked && lcb !== cb;
        });
        if (!anyOtherEnabled) {
          this.checked = true;
          return;
        }
      }
      
      var currentHidden = getHiddenLangs();
      
      if (isEnabled) {
        currentHidden = currentHidden.filter(function(l) { return l !== lang; });
      } else {
        if (!currentHidden.includes(lang)) {
          currentHidden.push(lang);
        }
      }
      saveHiddenLangs(currentHidden);
      applyLanguageSettings();
      
      // Если язык выключен, выключаем все его словари (и наоборот)
      updateDictsStateByLang(lang, isEnabled);
    });
  });

  // Initial dashboard sync after all checkboxes are set up
  updateLangDashboard();
}

// ── Language Dashboard (integrated into accordion headers) ──

function updateLangDashboard() {
  var countEls = document.querySelectorAll('.lang-dict-count');
  var totalActive = 0;
  var totalAll = 0;

  countEls.forEach(function(el) {
    var lang = el.getAttribute('data-lang');
    if (!lang) return;

    // Count active/total dicts
    var dicts = document.querySelectorAll('.dict-setting-checkbox[data-lang="' + lang + '"]');
    var total = dicts.length;
    var active = 0;
    dicts.forEach(function(d) { if (d.checked) active++; });
    totalAll += total;
    totalActive += active;

    // Update count text
    var activeEl = el.querySelector('.lang-count-active');
    var totalEl = el.querySelector('.lang-count-total');
    if (activeEl) activeEl.textContent = active;
    if (totalEl) totalEl.textContent = total;

    // Update count state class
    el.classList.remove('count-full', 'count-partial', 'count-off');
    var langCb = document.getElementById('lang-cb-' + lang);
    var langEnabled = langCb && langCb.checked;

    if (!langEnabled || active === 0) {
      el.classList.add('count-off');
    } else if (active === total) {
      el.classList.add('count-full');
    } else {
      el.classList.add('count-partial');
    }
  });

  // Update global summary
  var summaryCount = document.getElementById('summary-active-count');
  if (summaryCount) summaryCount.textContent = totalActive;
  var summaryTotal = document.getElementById('summary-total-count');
  if (summaryTotal) summaryTotal.textContent = totalAll;
}

// Экспортируем функции в глобальную область видимости
window.getHiddenLangs = getHiddenLangs;
window.getHiddenDicts = getHiddenDicts;
window.saveHiddenLangs = saveHiddenLangs;
window.saveHiddenDicts = saveHiddenDicts;
window.applyLanguageSettings = applyLanguageSettings;
window.toggleDictsList = toggleDictsList;
window.openDictDescTooltip = openDictDescTooltip;
window.getClickSearchSetting = getClickSearchSetting;
window.saveClickSearchSetting = saveClickSearchSetting;
window.initModalTabs = initModalTabs;
window.updateLangDashboard = updateLangDashboard;

